// extracted by mini-css-extract-plugin
module.exports = {"main":"sustainable_main__3SFJU"};